import { takeEvery, all } from "@redux-saga/core/effects";

import * as actionTypes from "store/types";
import { fetchAppSettingsStart, fetchAllPlansStart } from "store/common";
import {
  loginUserStart,
  createAccountStart,
  checkAuthStart,
  logoutStart,
  passwordResetStart,
  passwordValidateStart,
  updatePasswordAuthStart,
  fetchAllClientsVersionStart,
  updateClientVersionStart,
  addClientVersionStart,
  validateSubUserStart,
  createSubUserStart,
  fetchPromoDiscountStart,
  createPromoAccountStart,
  validate360Start,
  validateIbackupStart
} from "App/Auth/ducks";
import {
  fetchAccountDetailsStart,
  cancelAccountStart,
  updateProfileDetailsStart,
  updatePasswordStart,
  upgradePlanStart,
  updateCreditCardStart,
  fetchCCDetailsStart,
  fetchBillingInfoStart,
  fetchRenewalPriceStart,
  fetchUpgradeProChargeStart,
  fetchUserPlansStart,
  applyPendingChargesStart
} from "App/Account/ducks";
import {
  fetchClientsStart,
  downloadClientSetupStart,
  fetchClientStatusStart,
  fetchClientVersionInfoStart,
  fetchDeploymentTokenStart,
  downloadClientMSIStart,
  fetchGroupsStart,
  addClientsToGroupStart,
  deleteDashboardGroupStart,
  renameDashboardGroupNameStart,
  createNewGroupDashboardStart,
  removeClientsFromGroupStart,
  fetchClientServerIPAddressStart,
  createVirtualizationAccountStart,
  controlVMFromDashboardStart
} from "App/Dashboard/ducks";
import {
  fetchBackupSettingsStart,
  saveBackupSettingsStart,
  updateBackupSettingsStart,
  removeMachineStart,
  addClientsToPlanStart
} from "App/Dashboard/BackupSettings/ducks";
import {
  fetchFRRecoveryPointsStart,
  fetchFilesStart,
  patternSearch,
  downloadRestoreFilesStart,
  downloadRestoreISOStart
} from "App/Restore/Tabs/body/File/ducks";
import { fetchIRRecoveryPointsStart } from "App/Restore/Tabs/body/Image/ducks";
import {
  fetchAppLogsStart,
  fetchCFRLogsURLStart
} from "App/Dashboard/Logs/ducks";
import {
  fetchVMsListStart,
  fetchTaskStatusListStart,
  createVMTaskStart,
  controlVMStart,
  deleteVMStart,
  fetchVIRTRecoveryPointsStart,
  updateVMConfigurationsStart,
  rebuildVMStart,
  fetchVirtUserInfoStart
} from "App/Virtualization/ducks";
import { fetchActivityLogsStart } from "App/Activities/ducks";
import {
  inviteUsersStart,
  fetchUsersListStart,
  deleteSubUserStart,
  cancelUserInviteStart,
  resendInvitationStart
} from "App/Users/ducks";
import {
  fetchBackupPlansStart,
  enableBackupPlanStart,
  disableBackupPlanStart,
  deleteBackupPlanStart,
  fetchBackupPlansSettingStart,
  saveBackupPlansSettingStart,
  createNewBackupPlanStart,
  fetchDefaultPlanToCreatePlanStart
} from "App/BackupPlan/ducks";
import { closeSSEConnection } from "App/Virtualization/ducks";

export function* watchCommon() {
  yield takeEvery(actionTypes.FETCH_APP_SETTINGS_START, fetchAppSettingsStart);
  yield takeEvery(actionTypes.FETCH_ALL_PLANS_START, fetchAllPlansStart);
}

export function* watchDashboard() {
  yield all([
    takeEvery(actionTypes.FETCH_CLIENTS_START, fetchClientsStart),
    takeEvery(actionTypes.FETCH_CLIENT_STATUS_START, fetchClientStatusStart),
    takeEvery(
      actionTypes.DOWNLOAD_CLIENT_SETUP_START,
      downloadClientSetupStart
    ),
    takeEvery(actionTypes.FETCH_APP_LOGS_START, fetchAppLogsStart),
    takeEvery(actionTypes.FETCH_CFR_LOGS_URL_START, fetchCFRLogsURLStart),
    takeEvery(
      actionTypes.FETCH_CLIENT_VERSION_INFO_START,
      fetchClientVersionInfoStart
    ),
    takeEvery(
      actionTypes.FETCH_DEPLOYMENT_TOKEN_START,
      fetchDeploymentTokenStart
    ),
    takeEvery(actionTypes.DOWNLOAD_CLIENT_MSI_START, downloadClientMSIStart),
    takeEvery(actionTypes.FETCH_GROUPS_START, fetchGroupsStart),
    takeEvery(actionTypes.ADD_CLIENTS_TO_GROUP_START, addClientsToGroupStart),
    takeEvery(
      actionTypes.DELETE_DASHBOARD_GROUP_START,
      deleteDashboardGroupStart
    ),
    takeEvery(
      actionTypes.RENAME_DASHBOARD_GROUP_NAME_START,
      renameDashboardGroupNameStart
    ),
    takeEvery(
      actionTypes.CREATE_NEW_GROUP_DASHBOARD_START,
      createNewGroupDashboardStart
    ),
    takeEvery(
      actionTypes.REMOVE_CLIENTS_FROM_GROUP_START,
      removeClientsFromGroupStart
    ),
    takeEvery(
      actionTypes.FETCH_CLIENT_SERVERIPADDRESS_START,
      fetchClientServerIPAddressStart
    ),
    takeEvery(
      actionTypes.CREATE_VIRTUALIZATION_ACCOUNT_START,
      createVirtualizationAccountStart
    ),
    takeEvery(
      actionTypes.CONTROL_VM_FROM_DASHBOARD_START,
      controlVMFromDashboardStart
    )
  ]);
}

export function* watchBackup() {
  yield all([
    takeEvery(
      actionTypes.FETCH_BACKUP_SETTINGS_START,
      fetchBackupSettingsStart
    ),
    takeEvery(actionTypes.SAVE_BACKUP_SETTINGS_START, saveBackupSettingsStart),
    takeEvery(
      actionTypes.UPDATE_BACKUP_SETTINGS_START,
      updateBackupSettingsStart
    ),
    takeEvery(actionTypes.REMOVE_MACHINE_START, removeMachineStart),
    takeEvery(actionTypes.ADD_CLIENTS_TO_PLAN_START, addClientsToPlanStart)
  ]);
}

export function* watchRestore() {
  yield all([
    takeEvery(
      actionTypes.FETCH_FR_RECOVERY_POINTS_START,
      fetchFRRecoveryPointsStart
    ),
    takeEvery(actionTypes.FETCH_FILES_START, fetchFilesStart),
    takeEvery(actionTypes.PATTERN_SEARCH_START, patternSearch),
    takeEvery(
      actionTypes.DOWNLOAD_RESTORE_FILES_START,
      downloadRestoreFilesStart
    ),
    takeEvery(
      actionTypes.FETCH_IR_RECOVERY_POINTS_START,
      fetchIRRecoveryPointsStart
    ),
    takeEvery(actionTypes.DOWNLOAD_RESTORE_ISO_START, downloadRestoreISOStart)
  ]);
}

export function* watchAuth() {
  yield all([
    takeEvery(actionTypes.LOGIN_USER_START, loginUserStart),
    takeEvery(actionTypes.CREATE_ACCOUNT_START, createAccountStart),
    takeEvery(actionTypes.CHECK_AUTH_START, checkAuthStart),
    takeEvery(actionTypes.LOGOUT_USER, logoutStart),
    takeEvery(actionTypes.PASSWORD_RESET_START, passwordResetStart),
    takeEvery(actionTypes.PASSWORD_VALIDATE_START, passwordValidateStart),
    takeEvery(actionTypes.UPDATE_PASSWORD_AUTH_START, updatePasswordAuthStart),
    takeEvery(
      actionTypes.FETCH_ALL_CLIENTS_VERSION_START,
      fetchAllClientsVersionStart
    ),
    takeEvery(
      actionTypes.UPDATE_CLIENT_VERSION_START,
      updateClientVersionStart
    ),
    takeEvery(actionTypes.ADD_CLIENT_VERSION_START, addClientVersionStart),
    takeEvery(actionTypes.VALIDATE_SUB_USER_START, validateSubUserStart),
    takeEvery(actionTypes.CREATE_SUB_USER_START, createSubUserStart),
    takeEvery(actionTypes.FETCH_PROMO_DISCOUNT_START, fetchPromoDiscountStart),
    takeEvery(actionTypes.CREATE_PROMO_ACCOUNT_START, createPromoAccountStart),
    takeEvery(actionTypes.VALIDATE_360_START, validate360Start),
    takeEvery(actionTypes.VALIDATE_IBACKUP_START, validateIbackupStart)
  ]);
}

export function* watchAccount() {
  yield all([
    takeEvery(actionTypes.CANCEL_ACCOUNT_START, cancelAccountStart),
    takeEvery(
      actionTypes.FETCH_ACCOUNT_DETAILS_START,
      fetchAccountDetailsStart
    ),
    takeEvery(
      actionTypes.UPDATE_PROFILE_DETAILS_START,
      updateProfileDetailsStart
    ),
    takeEvery(actionTypes.UPDATE_PASSWORD_START, updatePasswordStart),
    takeEvery(actionTypes.UPGRADE_PLAN_START, upgradePlanStart),
    takeEvery(actionTypes.UPDATE_CREDIT_CARD_START, updateCreditCardStart),
    takeEvery(actionTypes.FETCH_CC_DETAILS_START, fetchCCDetailsStart),
    takeEvery(actionTypes.FETCH_BILLING_INFO_START, fetchBillingInfoStart),
    takeEvery(actionTypes.FETCH_RENEWAL_PRICE_START, fetchRenewalPriceStart),
    takeEvery(
      actionTypes.APPLY_PENDING_CHARGES_START,
      applyPendingChargesStart
    ),
    takeEvery(
      actionTypes.FETCH_UPGRADE_PROP_CHARGES_START,
      fetchUpgradeProChargeStart
    ),
    takeEvery(actionTypes.FETCH_USER_PLANS_START, fetchUserPlansStart)
  ]);
}

export function* watchVirtualization() {
  yield all([
    takeEvery(actionTypes.FETCH_VIRTUAL_MACHINES_LIST_START, fetchVMsListStart),
    takeEvery(actionTypes.CREATE_VIRTUAL_MACHINE_TASK_START, createVMTaskStart),
    takeEvery(
      actionTypes.FETCH_TASK_STATUS_LIST_START,
      fetchTaskStatusListStart
    ),
    takeEvery(actionTypes.CONTROL_VM_START, controlVMStart),
    takeEvery(actionTypes.DELETE_VM_START, deleteVMStart),
    takeEvery(
      actionTypes.FETCH_VIRT_RECOVERY_POINTS_START,
      fetchVIRTRecoveryPointsStart
    ),
    takeEvery(
      actionTypes.UPDATE_VM_CONFIGURATIONS_START,
      updateVMConfigurationsStart
    ),
    takeEvery(actionTypes.REBUILDVM_START, rebuildVMStart),
    takeEvery(actionTypes.VIRT_USER_INFO_START, fetchVirtUserInfoStart),
    takeEvery(actionTypes.CLOSE_SSE_CONNECTION, closeSSEConnection)
  ]);
}

export function* watchUsers() {
  yield all([
    takeEvery(actionTypes.INVITE_USERS_START, inviteUsersStart),
    takeEvery(actionTypes.FETCH_USERS_LIST_START, fetchUsersListStart),
    takeEvery(actionTypes.RESEND_INVITATION_START, resendInvitationStart),
    takeEvery(actionTypes.DELETE_SUBUSER_START, deleteSubUserStart),
    takeEvery(actionTypes.CANCEL_SUBUSER_INVITE_START, cancelUserInviteStart)
  ]);
}

export function* watchActivities() {
  yield takeEvery(
    actionTypes.FETCH_ACTIVITY_LOGS_START,
    fetchActivityLogsStart
  );
}

export function* watchBackupPlan() {
  yield all([
    takeEvery(actionTypes.FETCH_BACKUP_PLANS_START, fetchBackupPlansStart),
    takeEvery(actionTypes.ENABLE_BACKUP_PLAN_START, enableBackupPlanStart),
    takeEvery(actionTypes.DISABLE_BACKUP_PLAN_START, disableBackupPlanStart),
    takeEvery(actionTypes.DELETE_BACKUP_PLAN_START, deleteBackupPlanStart),
    takeEvery(
      actionTypes.FETCH_BACKUP_PLANS_SETTING_START,
      fetchBackupPlansSettingStart
    ),
    takeEvery(
      actionTypes.SAVE_BACKUP_PLANS_SETTING_START,
      saveBackupPlansSettingStart
    ),
    takeEvery(
      actionTypes.CREATE_NEW_BACKUP_PLAN_START,
      createNewBackupPlanStart
    ),
    takeEvery(
      actionTypes.FETCH_DEFAULT_BACKUP_PLAN_TO_CREATE_PLAN_START,
      fetchDefaultPlanToCreatePlanStart
    )
  ]);
}

// export const stopSSEConnection = () => (dispatch) => {
//   closeSSEConnection();
//   dispatch({ type: "STOP_SSE_CONNECTION" });
// };
